import { render, staticRenderFns } from "./Barredores.vue?vue&type=template&id=d95e8c56"
import script from "./Barredores.vue?vue&type=script&lang=ts"
export * from "./Barredores.vue?vue&type=script&lang=ts"
import style0 from "./Barredores.vue?vue&type=style&index=0&id=d95e8c56&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports